import { render } from "./doctor-dashboard.vue?vue&type=template&id=0e586788"
import script from "./doctor-dashboard.vue?vue&type=script&lang=js"
export * from "./doctor-dashboard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__